import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import { ReactComponent as Ai } from '../../assets/ai_post.svg';
import AiTextButton from '../AiTextButton/AiTextButton';
import { ChatBox } from '../ChatBox/ChatBox';
import { $createTextNode, $getRoot, $getSelection, $isRangeSelection } from 'lexical';

const AiChatWrapper = () => {
  const [aiModalVisibility, setAiModalVisibility] = useState(false);
  const [isOpenAi, setIsOpenAi] = useState(false);
  const editor = useSelector((state) => state.editor.lexicalEditor);
  const isReadOnly = useSelector((state) => state.editor.isReadOnly);
  const isUiLocked = useSelector((state) => state.editor.isUiLocked);
  const conflictPreviewVerion = useSelector((state) => state.editor.conflictPreviewVerion);

  // While a cached preview is on screen and the fresh document is still loading
  // in the background the whole UI is read-only, so AI generation must be off too.
  const interactionsDisabled = isReadOnly || isUiLocked;

  const showAiText = (text) => {
    if (editor) {
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          selection.insertText(text);
        } else {
          const rootNode = $getRoot();
          rootNode.append($createTextNode(text));
        }
      });
    }
  };

  if (conflictPreviewVerion) return null;

  return (
    <>
      <Button className='AI-icon' title='Generate with AI' type="text" icon={<Ai />} onClick={() => { if (!interactionsDisabled) setAiModalVisibility(true) }} disabled={interactionsDisabled} style={{ position: 'fixed', bottom: '110px', right: '60px', zIndex: 999 }} />
      <AiTextButton
        isOpen={isOpenAi}
        setIsOpenAi={setIsOpenAi}
        showAiText={showAiText}
        setAiModalVisibility={setAiModalVisibility}
        aiModalVisibility={aiModalVisibility}
      />
      <div className='chatbox-container'>
        <ChatBox />
      </div>
    </>
  );
};

export default AiChatWrapper;